import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Πόσο διαρκεί μια συνεδρία και πόσο συχνά γίνονται;",
    a: "Κάθε συνεδρία διαρκεί περίπου 50 λεπτά. Στην αρχή της θεραπείας οι συνεδρίες πραγματοποιούνται συνήθως μία φορά την εβδομάδα, ενώ η συχνότητα μπορεί να προσαρμοστεί καθώς η διαδικασία εξελίσσεται.",
  },
  {
    q: "Πώς ξεκινά η θεραπευτική σχέση;",
    a: "Στην πρώτη συνεδρία γνωριζόμαστε, μιλάμε για αυτό που σε φέρνει εδώ και διαμορφώνουμε από κοινού τους στόχους της θεραπείας. Δεν υπάρχει καμία δέσμευση πριν νιώσεις άνετα να συνεχίσεις.",
  },
  {
    q: "Είναι εμπιστευτικές οι συνεδρίες;",
    a: "Ναι. Όλες οι συνεδρίες προστατεύονται από αυστηρό απόρρητο, σύμφωνα με τον κώδικα δεοντολογίας των ψυχολόγων και τη σχετική νομοθεσία.",
  },
  {
    q: "Πώς λειτουργούν οι online συνεδρίες;",
    a: "Πραγματοποιούνται μέσω ασφαλούς πλατφόρμας βιντεοκλήσης. Χρειάζεσαι μια σταθερή σύνδεση στο διαδίκτυο και έναν ήσυχο, ιδιωτικό χώρο.",
  },
  {
    q: "Μπορεί η CBT να με βοηθήσει στο δικό μου ζήτημα;",
    a: "Η Γνωσιακή Συμπεριφορική Θεραπεία είναι τεκμηριωμένη για ένα ευρύ φάσμα δυσκολιών — από άγχος και OCD μέχρι ζητήματα αυτοεκτίμησης και διατροφικές δυσκολίες. Στην πρώτη συνάντηση θα συζητήσουμε αν είναι η πιο κατάλληλη προσέγγιση για εσένα.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32">
      <div className="max-w-[920px] mx-auto px-6 sm:px-12">
        <motion.p
          {...fadeUp}
          className="text-[11px] tracking-[0.25em] uppercase font-body font-medium text-primary mb-5 text-center"
        >
          FAQ
        </motion.p>
        <motion.h2
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.05 }}
          data-testid="faq-heading"
          className="font-heading font-medium tracking-tight text-foreground text-4xl sm:text-5xl lg:text-[58px] leading-[1.05] text-center"
        >
          Συχνές <span className="italic font-light">ερωτήσεις.</span>
        </motion.h2>

        <motion.div
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.15 }}
          className="mt-14"
        >
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-border/60 last:border-0"
              >
                <AccordionTrigger className="font-heading text-left text-xl sm:text-2xl text-foreground hover:no-underline py-6 hover:text-primary transition-colors">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="font-body font-light text-base sm:text-lg text-foreground/75 leading-relaxed pb-7 pr-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
